import {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import {LibraryPage} from './pages/Library/Library.page';
import {LibrarySelectionPage} from './pages/Library/LibrarySelection.page';

import LibraryV1 from './data/libraries/libraries.v1.json';
import LibraryV2 from './data/libraries/libraries.v2.json';
import {ModulePage} from './pages/Module/Module.page';
import {PlanningPage} from './pages/Planning/Planning.page';
import {Layout} from './components/LayoutComponents';
import {RouteService} from './services/route.service';
import {PtVersion} from './services/pt-storage.service';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {ModuleContext} from './types';
import {ChakraProvider} from '@chakra-ui/react';
import {AnimatePresence} from 'framer-motion';
import theme from './theme/theme';
import {TemplatePage} from './pages/Template/Template.page';
import {ClassesPage} from './pages/Class/Classes.page';
import {HelpPage} from './pages/Help/Help.page';
import {OverviewPage} from './pages/Overview/Overview.page';
import {WhiteboardPage} from './pages/Whiteboard/Whiteboard.page';
import {FeaturePage} from './pages/Feature/Feature.page';
import TestPage from './pages/Test/Test.page';

const libSelectionV1 = RouteService.librarySelection(
  PtVersion.LibraryGroupsPerSubject
);
const libSelectionV2 = RouteService.librarySelection(
  PtVersion.LibraryGroupsPerClass
);
if (window.location.pathname === '/') {
  window.location.replace(
    window.location.hostname.startsWith('tc4-v1')
      ? libSelectionV1
      : libSelectionV2
  );
}

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <AnimatePresence exitBeforeEnter>
          <Routes>
            <Route path='/overview' element={<OverviewPage />} />
            <Route path='/whiteboard' element={<WhiteboardPage />} />

            <Route
              path={libSelectionV2}
              element={<LibrarySelectionPage libraryGroups={LibraryV2} />}
            />
            <Route path='/library/:libraryId' element={<LibraryPage />} />
            <Route path='/planning' element={<PlanningPage />} />
            <Route
              path='/library/:libraryId/:moduleId'
              element={<ModulePage context={ModuleContext.Library} />}
            />
            <Route
              path='/planning/:libraryId/:moduleId'
              element={<ModulePage context={ModuleContext.Planning} />}
            />
            <Route path='/classes' element={<ClassesPage />} />
            <Route path='/help' element={<HelpPage />} />
            <Route
              path='/template'
              element={<TemplatePage children={undefined} />}
            />
            <Route path='/feature' element={<FeaturePage />} />
            <Route path='/test' element={<TestPage children={<p>test</p>} />} />
          </Routes>
        </AnimatePresence>
      </BrowserRouter>
    </ChakraProvider>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
